module.exports = __webpack_public_path__ + "img/nr.d16edc69.svg";